import api from '@/services/api/api'

class BasicUserInfoService {
  getBasicUserInfo () {
    return api.get('user/basic-info').then(response => {
      return response.data
    })
  }

  editBasicUserInfo (basicUserInfo) {
    if (basicUserInfo.email === '') {
      basicUserInfo.email = null
    }
    if (basicUserInfo.phone === '') {
      basicUserInfo.phone = null
    }
    return api.post('user/basic-info', basicUserInfo)
  }
}

export default new BasicUserInfoService()



// WEBPACK FOOTER //
// ./src/services/user/BasicUserInfoService.js